/**
 * recipe-print.js — Print the structured recipe card, not the whole page.
 *
 * Capture-phase click on [data-recipe-print] or .blog-recipe-print__btn so
 * the below-card control cannot fall through to window.print() of the article.
 * CSS in recipe-card.liquid hides everything else while printing.
 */
(function () {
  'use strict';

  var html = document.documentElement;
  var printHost = null;
  var printing = false;

  function cleanup() {
    html.classList.remove('printing-recipe-card');
    if (printHost && printHost.parentNode) {
      printHost.parentNode.removeChild(printHost);
    }
    printHost = null;
    printing = false;
    window.removeEventListener('afterprint', cleanup);
  }

  function cardForButton(btn) {
    return (
      btn.closest('.recipe-card') ||
      document.querySelector('.recipe-card')
    );
  }

  function printRecipeCard(card) {
    if (!card || printing) return;
    printing = true;

    try {
      if (printHost && printHost.parentNode) {
        printHost.parentNode.removeChild(printHost);
      }

      printHost = document.createElement('div');
      printHost.className = 'recipe-print-host';

      var brand = document.createElement('div');
      brand.className = 'recipe-print-host__brand';
      var logoSrc = card.getAttribute('data-print-logo');
      var logoImg = null;
      if (logoSrc) {
        logoImg = document.createElement('img');
        logoImg.alt = '';
        logoImg.className = 'recipe-print-host__brandlogo';
        brand.appendChild(logoImg);
      }
      var wordmark = document.createElement('span');
      wordmark.innerHTML =
        '<span class="recipe-print-host__brandmark">Sidekick Soda</span>' +
        '<span class="recipe-print-host__branddot" aria-hidden="true">·</span>' +
        '<span class="recipe-print-host__brandsub">Recipes</span>';
      wordmark.className = 'recipe-print-host__brandtext';
      brand.appendChild(wordmark);
      printHost.appendChild(brand);

      var heroSrc = card.getAttribute('data-print-hero');
      var heroAlt = card.getAttribute('data-print-hero-alt') || '';
      var heroImg = null;
      if (heroSrc) {
        var hero = document.createElement('figure');
        hero.className = 'recipe-print-host__hero';
        heroImg = document.createElement('img');
        heroImg.alt = heroAlt;
        hero.appendChild(heroImg);
        printHost.appendChild(hero);
      }

      printHost.appendChild(card.cloneNode(true));

      var domain =
        card.getAttribute('data-print-domain') ||
        window.location.hostname ||
        'sidekicksoda.co.nz';
      var qrUrl = card.getAttribute('data-print-qr-url') || '';
      var cta = document.createElement('div');
      cta.className = 'recipe-print-host__cta';

      var qrImg = null;
      var qrSrc = '';
      if (qrUrl) {
        qrSrc =
          'https://api.qrserver.com/v1/create-qr-code/?size=240x240&margin=2&data=' +
          encodeURIComponent(qrUrl);
        qrImg = document.createElement('img');
        qrImg.alt =
          card.getAttribute('data-print-qr-mode') === 'shop'
            ? 'Scan to shop this flavour'
            : 'Scan to browse more recipes';
        qrImg.className = 'recipe-print-host__cta-qr';
        cta.appendChild(qrImg);
      }

      var qrMode = card.getAttribute('data-print-qr-mode') || 'browse';
      var qrFlavour = card.getAttribute('data-print-qr-flavour') || '';
      var ctaTagline;
      var ctaScan;
      if (qrMode === 'shop') {
        ctaTagline = qrFlavour
          ? 'Loved it? Get ' + qrFlavour + ' Sidekick at'
          : 'Loved it? Get the soda for this recipe at';
        ctaScan = 'Scan to shop this flavour';
      } else {
        ctaTagline = 'More delicious recipes &amp; real-fruit sodas at';
        ctaScan = 'Scan to browse all our recipes';
      }

      var ctaText = document.createElement('div');
      ctaText.className = 'recipe-print-host__cta-text';
      ctaText.innerHTML =
        '<p class="recipe-print-host__cta-tagline">' +
        ctaTagline +
        '</p>' +
        '<p class="recipe-print-host__cta-url">' +
        domain +
        '</p>' +
        (qrImg ? '<p class="recipe-print-host__cta-scan">' + ctaScan + '</p>' : '');
      cta.appendChild(ctaText);
      printHost.appendChild(cta);

      document.body.appendChild(printHost);
      html.classList.add('printing-recipe-card');
      window.addEventListener('afterprint', cleanup);

      var images = [];
      if (logoImg) images.push({ el: logoImg, src: logoSrc });
      if (heroImg) images.push({ el: heroImg, src: heroSrc });
      if (qrImg) images.push({ el: qrImg, src: qrSrc });

      var printed = false;
      var doPrint = function () {
        if (printed) return;
        printed = true;
        window.print();
      };

      if (images.length === 0) {
        doPrint();
        return;
      }

      var pending = images.length;
      var oneDone = function () {
        pending -= 1;
        if (pending <= 0) doPrint();
      };
      images.forEach(function (img) {
        img.el.addEventListener('load', oneDone);
        img.el.addEventListener('error', oneDone);
        img.el.src = img.src;
      });
      setTimeout(doPrint, 1500);
    } catch (e) {
      cleanup();
    }
  }

  document.addEventListener(
    'click',
    function (event) {
      var btn = event.target.closest
        ? event.target.closest('[data-recipe-print], .blog-recipe-print__btn')
        : null;
      if (!btn) return;

      var card = cardForButton(btn);
      if (!card) return;

      event.preventDefault();
      event.stopPropagation();
      if (typeof event.stopImmediatePropagation === 'function') {
        event.stopImmediatePropagation();
      }
      printRecipeCard(card);
    },
    true
  );
})();
